import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Going strong",
  "description": "",
  "published": "2006-04-24T00:00:00.000Z",
  "redirect_from": ["/blog/going-strong/swizec/428"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Quite some things have happened to the website as sidebars have been added, with the google ads and the tagboard and so on. The nastiest of the endeavours was trying to get the page to display properly in different browsers and I managed to make it work in both FF and Opera, but it still doesn't work quite well in IE and is downright nasty (although still useful) in konqueror.`}</p>
    <p>{`Cross-browser support is really strange, if you have a 400px wide image above a 400px wide div, somehow those two are of different widths by 2px in just about every browser save for Opera. This strikes me as severely odd, but it has a simple workaround... still seems rather silly.`}</p>
    <p>{`Wanted to make a placeholder instead of the first comic but didn't quite get around to colouring it just yet, so it, and some banners, should most probably be put on the site sometime tomorow`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      